//ai.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Contact } from '../models/contact';
import { Appointment } from '../models/appointment';
import { Property } from '../models/property';
import { Invoice } from '../models/invoice';
import { Quote } from '../models/quote';
import { Business } from '../models/business';
import { WorkItem } from '../models/work-item';
import { Job } from '../models/job';
import { Payment } from '../models/payment';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, tap, switchMap } from 'rxjs/operators';

import { ModalController, PickerController, AlertController } from '@ionic/angular';
import { ApiService } from './api.service';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  // API path
  base_path = environment.API_URL;

  constructor(
    private http: HttpClient,
    private alertController: AlertController,
    private apiService: ApiService) { }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  }

  noAccountHttpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Skip-Account-Interceptor': 'true'
    })
  }

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    console.log(error);
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };

  async jobDescriptionPrompt(businessId: number): Promise<WorkItem[]> {
    let isProcessing = false; // Flag to track if the request is in progress

    return new Promise<WorkItem[]>(async (resolve, reject) => {
      const alert = await this.alertController.create({
        header: 'Generate Items',
        message: 'Enter a description: You can be very specific with items and prices, or just start with a general description.',
        cssClass: 'custom-alert',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'alert-button-cancel',
            handler: () => {
              if (isProcessing) return false; // Prevent action if processing
              console.log('Alert canceled');
              reject('Alert canceled'); // Reject the promise if canceled
            },
          },
          {
            text: 'Go',
            cssClass: 'alert-button-confirm',
            handler: async (data) => {
              // Close the alert manually when "Go" is clicked
              alert.dismiss().then(() => {
                this.workitemGeneration(businessId, data.description)
                  .toPromise()
                  .then(workItems => {
                    resolve(workItems); // Resolve with the actual work items
                  })
                  .catch(error => {
                    reject(error); // Reject on error
                  });
              });
              return false; // Prevent the alert from closing automatically
            },
          },
        ],
        inputs: [
          {
            type: 'textarea',
            placeholder: 'Job Description',
            name: 'description', // Ensure the input name matches what you access in the handler
            value: '',
          },
        ],
      });
  
      await alert.present();
    });
  }

  workitemGeneration(businessId:number, jobDescription:string): Observable<WorkItem[]> {
    const body = { jobDescription };
    return this.http
      .post<any>(this.base_path+'businesses/' + businessId + '/generate-work-items', JSON.stringify(body), this.httpOptions)
      .pipe(
        map(data => data.data.map(data => new WorkItem().deserialize(data))),
        catchError(this.handleError)
      )
  }

}